const BASIC_ACCOUNT_MODES = [ 'REQUIRED', 'OPTIONAL', 'HIDDEN' ];
const PARTNER_MODES = [ 'FIXED', 'SELECTABLE' ];
const POLLING_STATUSES = [ '5', '11', '13', '14' ];

function featureEnabled(value) {
  return value !== false;
}

function getBasicAccountPolicy(mode, basicPayRequired) {
  if (!BASIC_ACCOUNT_MODES.includes(mode)) {
    throw new Error('不支持的基本户模式');
  }
  const visible = mode !== 'HIDDEN';
  return {
    visible,
    required: mode === 'REQUIRED',
    showPayTip: visible && Boolean(basicPayRequired),
    basicNeed: visible && basicPayRequired ? 1 : 0,
  };
}

function normalizeUiProfile(profile) {
  const source = profile || {};
  if (!BASIC_ACCOUNT_MODES.includes(source.basicAccountMode)) {
    throw new Error('不支持的基本户模式');
  }
  if (!PARTNER_MODES.includes(source.partnerMode)) {
    throw new Error('不支持的机构模式');
  }
  if (source.partnerMode === 'FIXED' && !source.defaultPartnerCode) {
    throw new Error('固定机构配置不完整');
  }
  return {
    basicAccountMode: source.basicAccountMode,
    basicPayRequired: Boolean(source.basicPayRequired),
    partnerMode: source.partnerMode,
    defaultPartnerCode: source.defaultPartnerCode || '',
    requiredFileFormat: source.requiredFileFormat || '',
    periodEnabled: featureEnabled(source.periodEnabled),
    captchaEnabled: featureEnabled(source.captchaEnabled),
    smsVerificationEnabled: featureEnabled(source.smsVerificationEnabled),
    giveUpEnabled: featureEnabled(source.giveUpEnabled),
  };
}

function selectInitialPartner(partners, profile, currentPartnerCode) {
  const list = Array.isArray(partners) ? partners : [];
  if (!list.length) return null;
  if (profile.partnerMode === 'FIXED') {
    return list.find(item => item.partnerCode === profile.defaultPartnerCode) || null;
  }
  return list.find(item => item.partnerCode === currentPartnerCode) || list[0];
}

function getVisiblePartners(partners, profile) {
  const list = Array.isArray(partners) ? partners : [];
  if (!profile || profile.partnerMode !== 'FIXED') return list;
  return list.filter(item => item.partnerCode === profile.defaultPartnerCode);
}

function buildInformationPayload(context, profile, values) {
  const normalized = normalizeUiProfile(profile);
  const accountPolicy = getBasicAccountPolicy(
    normalized.basicAccountMode,
    normalized.basicPayRequired
  );
  const partnerCode = normalized.partnerMode === 'FIXED'
    ? normalized.defaultPartnerCode
    : values.partnerCode;
  if (!context || !context.orderNo) throw new Error('订单号为空');
  if (!partnerCode) throw new Error('请选择出函机构');
  const payload = {
    orderNo: context.orderNo,
    partnerCode,
    basicNeed: accountPolicy.basicNeed,
    responsiblePersonName: values.responsiblePersonName,
    responsiblePersonPhone: values.responsiblePersonPhone,
    basicAccountName: accountPolicy.visible ? (values.basicAccountName || '') : '',
    basicAccountNo: accountPolicy.visible ? (values.basicAccountNo || '') : '',
  };
  if (normalized.smsVerificationEnabled) payload.phoneCode = values.phoneCode || '';
  return payload;
}

function getOrderStep(status) {
  if (String(status) === '1') return 0;
  if (String(status) === '2') return 1;
  return 2;
}

function getProgressStatus(status) {
  const normalized = String(status || '');
  if (normalized === '13') return 11;
  const supported = [ '1', '2', '5', '7', '11', '14', '21', '31', '32', '33' ];
  return supported.includes(normalized) ? Number(normalized) : 5;
}

function shouldPollOrderStatus(status) {
  return POLLING_STATUSES.includes(String(status));
}

function isOrderPollingGenerationActive(generation, currentGeneration, destroyed) {
  return !destroyed && generation === currentGeneration;
}

function normalizeDocumentUrl(rawUrl, origin) {
  if (!rawUrl || !origin) return '';
  try {
    const target = new URL(rawUrl, origin);
    if (!/^https?:$/.test(target.protocol) || target.origin !== origin) return '';
    return target.href;
  } catch (error) {
    return '';
  }
}

function normalizeDocumentFiles(rawFiles, origin) {
  let items = [];
  if (Array.isArray(rawFiles)) {
    items = rawFiles;
  } else if (rawFiles && typeof rawFiles === 'object') {
    items = Object.keys(rawFiles).map(name => {
      const value = rawFiles[name];
      return value && typeof value === 'object'
        ? { name, ...value }
        : { name, path: value };
    });
  }
  return items.reduce((result, file, index) => {
    const source = typeof file === 'string' ? file : (file && (file.path || file.url));
    const path = normalizeDocumentUrl(source, origin);
    if (path) {
      result.push({
        path,
        name: typeof file === 'string'
          ? `相关文件${index + 1}`
          : (file.name || `相关文件${index + 1}`),
      });
    }
    return result;
  }, []);
}

function normalizeNoticeText(rawNotice) {
  if (!rawNotice) return '';
  return String(rawNotice)
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\s*\/\s*(p|div|li|h[1-6])\s*>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(Boolean)
    .join('\n');
}

module.exports = {
  buildInformationPayload,
  getBasicAccountPolicy,
  getOrderStep,
  getProgressStatus,
  getVisiblePartners,
  isOrderPollingGenerationActive,
  normalizeDocumentFiles,
  normalizeDocumentUrl,
  normalizeNoticeText,
  normalizeUiProfile,
  selectInitialPartner,
  shouldPollOrderStatus,
};
